import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { ConfigContext } from '../components/shared/ConfigContext';

const useCompanyName = () => {
  const config = useContext(ConfigContext);
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    if (!config) return;
    const cid = localStorage.getItem('companyId');
    if (!cid) return;
    axios.get(`${config.backendUrl}/companies/${cid}`)
      .then((response) => setCompanyName(response.data.companyName || 'Company'))
      .catch((error) => {
        console.error('Error fetching company info:', error);
        setCompanyName('Company');
      });
  }, [config]);

  return companyName;
};

export default useCompanyName;
